import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <strong>Feedstock (Lignocellulosic residues): </strong>Dried paddy
              and wheat straw were dried at 50-60<sup>o</sup>C for 15-20 min,
              pulverized using a grinder, and then sieved to get powder of &lt;
              0.1mm. These samples were stored in air-tight zip lock covers for
              further analysis.
            </p>
            <p>
              <strong>Pretreatment of feedstock (bio-residues):</strong> Dilute
              acid pretreatment was carried out using 2% H<sub>2</sub>SO
              <sub>4</sub> for 10g of straw and autoclaved at 121<sup>o</sup>C
              for 45min. After pretreatment, the biomass was washed with
              distilled water and subjected to simultaneous saccharification and
              fermentation (SSF).
            </p>
            <p>
              <strong>Fermentation of bio-residues:</strong> Saccharification
              was carried out using <em>Vibrio parahaemolyticus</em> isolated
              from marine source exhibiting higher cellulolytic activity. Yeast
              strain <em>Pichia kudriavzevii</em> isolated from toddy strain
              exhibiting thermotolerance was selected for fermentation. SSF was
              carried out at 55<sup>o</sup>C, 100 rpm for 24h. Reducing sugar
              after hydrolysis was estimated using DNS method. The ethanol
              present in the fermented broth was analysed using GC-FID.
            </p>
            <p>
              <strong>SEM analysis:</strong> Lignocellulosic biomass surface
              morphology (untreated, acid-treated and enzyme-treated biomass)
              was qualitatively analyzed using SEM (JEOL-IT 300). Pulverized
              straw samples were placed on an aluminium specimen mount using
              conductive carbon tape. Sputter gold coating was performed to
              prevent charging. Samples were then examined in SEM under vacuum
              conditions at an accelerating voltage of 10 kV
            </p>
            <br />
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ea3.png" alt="" />{" "}
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} colSpan="7" width="102%">
                    <p style={{ textAlign: "center" }}>
                      <strong>Fig 2</strong>. Schematic representation of
                      bioethanol production using lignocellulosic biomass
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
